module.exports = __webpack_public_path__ + "media/images/emblems/Castaneda_wappen-d534e046330ac4c2a8de0bd64518079b.svg";